/**
 * Duo route contracts (design 5.3.1): one endpoint per frontend-consumed
 * (method, path) on the Duo integration surface. The worker registers its
 * handlers through these (worker/src/features/duo/api.ts); the frontend
 * client (frontend/src/features/duo/client.js) invokes the same objects.
 *
 * Same-path pairs (GET + PUT /api/integrations/duo) are contracted
 * separately — contracts are method-aware.
 */

import { defineContracts, endpoint } from '../featureModule'
import { identity } from './duo'

export const contracts = defineContracts(identity, {
  /** GET /api/integrations/duo — the duo integration row (config redacted). */
  getIntegration: endpoint('GET', '/api/integrations/duo', { entitlement: 'duo' }),
  /** PUT /api/integrations/duo — update credentials/enabled/1P references. */
  updateIntegration: endpoint('PUT', '/api/integrations/duo', { entitlement: 'duo' }),
  /** POST /api/integrations/duo/test — signed Duo Auth API ping. */
  testIntegration: endpoint('POST', '/api/integrations/duo/test', { entitlement: 'duo' }),
})
